import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import postex from "../../../assets/images/postEx.png";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import "./Export.scss";
import { getLoadSheetCsvApi } from "live-slices/orders/thunk";
import tcsLogo from "../../../assets/images/tcsLogon.png";

const LordDownModal = ({ show, onCloseClick, countPage, isQuickCommerce }: any) => {
  const dispatch: any = useDispatch();

  const [selectedType, setSelectedType] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleExport = async () => {
    if (!startDate || !endDate || !selectedType) {
      alert("Please select date range and type.");
      return;
    }

const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
    try {
      const response: any = await dispatch(
        getLoadSheetCsvApi({
          type: selectedType,
          fromdate: formattedStartDate,
          todate: formattedEndDate,
        })
      );

      const csvContent = response?.payload;
      if (csvContent) {
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "loadsheet.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        onCloseClick(); // Close modal
      } 
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

    useEffect(() => {
    if (show) {
      setSelectedType("");
      setStartDate("");
      setEndDate("");
      setActiveIndex(null);
    }
  }, [show]);

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered className="ExportCSV-Modal">
      <ModalBody>
        <img
          data-testing-id="closeIcon"
          onClick={onCloseClick}
          className="closeIconModal"
          src={CLoseImg}
          alt=""
        />
        <div className="export-csv-modal">
          <div className="export-csv-header">
            <h4>Download Load Sheet</h4>
          </div>
          <div className="export-csv-content">
            <p>Select Type</p>
          </div>

          <div className="typeRow">
            {[0, 1].map((item, index) => (
              <div
                key={index}
                className={`itemDv ${activeIndex === index ? "active" : ""}`}
                onClick={() => {
                  setActiveIndex(index);
                  setSelectedType(index === 0 ? "tcs" : "postEx");
                }}
              >
                <img src={index === 0 ? tcsLogo : postex} alt="" />
                <p>{index === 0 ? "TCS" : "Postex"}</p>
              </div>
            ))}
          </div>

          <div className="DFlex">
            <div className="export-csv-Table">
              <div className="date-picker-container">
                <label className="from-date">Select From Date</label>
                <div className="input-wrapper">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="From Date"
                  />
                </div>
              </div>

              <div className="date-picker-container">
                <label className="from-date">Select To Date</label>
                <div className="input-wrapper">
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="To Date"
                    min={startDate || undefined}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="export-csv-button">
            <button
              onClick={handleExport}
              disabled={!startDate || !endDate || !selectedType}
            >
              Download
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

LordDownModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  countPage: PropTypes.number,
  isQuickCommerce: PropTypes.any,
};

export default LordDownModal;
